<template>
  <v-card class="card pa-4 " color="gray10" flat>
    <v-alert
      text
      class="mb-0 px-3 py-2"
      color="info"
      icon="$infoIcon"
      rounded="lg"
    >
      <p class="font-Light-16 text-justify">
        {{ $t("corporateAccount.guideCard.legalAccountReminder") }}
      </p>
    </v-alert>

    <v-card class="card pa-4 mt-3" color="gray8" flat>
      <h2 class="font-Light-16">{{ data.page_title }}</h2>
      <div class="text-justify gray2--text mt-4" v-html="data.page_content" />
    </v-card>
  </v-card>
</template>

<script>
import legalService from "@/services/modules/legalService";

export default {
  data() {
    return {
      data: null
    };
  },
  mounted() {
    legalService.getGuide().then(res => {
      this.data = res.data.data;
    });
  }
};
</script>
